import { NgClass, NgStyle } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TrackBarData, TrackbarService } from 'services/api/trackbar.service';

@Component({
    selector: 'track-bar-widget',
    templateUrl: './html/track-bar-widget.component.html',
    styleUrls: ['./css/track-bar-widget.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, NgStyle],
})
@UntilDestroy()
export class TrackBarWidgetComponent implements OnInit {
    @Input() primaryColour = '';
    @Input() secondaryColour = '';
    @Input() completedIcon = '';
    @Input() textColour = 'black';
    @Input() completeSectionTextColour = '';
    @Input() wrapLabel = true;

    tracks: TrackBarData[];
    percentage = '0';
    currentTrack: TrackBarData;

    constructor(
        private trackbarService: TrackbarService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.trackbarService
            .getTrackbarData()
            .pipe(untilDestroyed(this))
            .subscribe((data) => {
                this.tracks = data.tracks;
                this.currentTrack = data.currentTrack;
                this.percentage = data.percentage;
                this.cdr.detectChanges();
            });
    }
}
